<template>
  <div id="mydocfileTable">
    <el-upload ref="gentlyUpload" style="height: 0;" :action="actionUrl" :headers="Token" :show-file-list="false"
      :accept="accept" :on-error="handleError" :before-upload="handleBeforeUpload" :on-success="handleAvatarSuccess"
      :file-list="fileList">
      <el-button id="gentlyBtn" size="small" style="display:none;">
        轻量化
      </el-button>
    </el-upload>
    <el-table ref="multipleTable" :key="keyone" :data="list" tooltip-effect="dark" empty-text="" height="100%" class="tableCol"
      row-key="folderId" border @row-click="clickRow" @selection-change="selectChange">
      <template slot="empty">
        <img :src="zanwu" alt="" />
        <p style="font-size:16px;color:#000;">
          暂无数据
        </p>
      </template>
      <el-table-column type="selection" width="50" align="center" reserve-selection>
      </el-table-column>
      <el-table-column width="50" align="center">
        <template slot-scope="{ row }">
          <div style="display:flex;align-items: center;justify-content: flex-end">
            <!-- 收藏图标 -->
            <span v-if="row.isFavorite === 1" style="cursor:pointer;" @click.stop="delCol(row)">
              <img :src="shoucang" alt="" style="margin-right: 12px;margin-top: 4px;" />
            </span>
            <span v-if="row.isFavorite !== 1" style="cursor:pointer;" @click.stop="collectFile(row)">
              <img :src="weishoucang" alt="" style="margin-right: 12px;margin-top: 4px;" />
            </span>
          </div>
        </template>
      </el-table-column>

      <el-table-column ref="fileNameSort" :key="16" show-overflow-tooltip align="left" label="文件名称" prop="folderName">
        <template slot-scope="{ row, $index }">
          <div style="display:flex;align-items: center" class="colCheck">
            <!-- 轻量化图标 -->
            <fileLightFlag :row="row" @updateLight="updateLight" />

            <!-- 文件的图标 -->
            <img :src="className(row)" style="flex-shrink:0;margin:0px 5px;" />
            <!-- 重命名 -->
            <div v-if="isShowRechristen[$index]" class="rechristen">
              <el-input :ref="'input' + row.folderId" v-model="rechristenCommitName" style="width:60%" size="small" @blur="blur"></el-input>
              <el-button type="primary" style="margin-left: 5px" size="small" @click.stop="commit(row)">
                确定
              </el-button>
              <el-button style="margin-left: 3px" size="small" @click.stop="isShowRechristen = []">
                取消
              </el-button>
            </div>
            <!-- 文件名称 -->
            <div v-else :style="{
              cursor:
                cacheListContent.createFolder.folderId === 'recycle'
                  ? ''
                  : 'pointer',
            }" @click.stop="clickFolderFile(row, $event)">
              <span style="width:80%;">{{ row.folderName }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :key="15" align="center" label="操作" width="220">
        <template slot-scope="scope">
          <div class="more">
            <i v-if="deleMydoc" class="el el-icon-delete rowIcon" title="删除" @click.stop="deleteRow(scope.row)"></i>
            <i class="el el-icon-edit rowIcon" title="重命名" @click.stop="rechristen(scope)"></i>
            <i v-if="downMydoc" class="el el-icon-download rowIcon" title="下载"
              @click.stop="downloadFile(scope.row)"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column :key="11" prop="fileSize" align="center" label="文件大小" :formatter="formatterFileSize"
        show-overflow-tooltip width="220">
      </el-table-column>
      <el-table-column ref="upTimeSort" :key="8" width="220" prop="checkInDate" align="center" label="修改时间"
        show-overflow-tooltip sortable>
        <template slot-scope="{ row }">
          <span>{{
            row.checkInDate === '1900-01-01 00:00:00' ? '' : row.checkInDate
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <share v-if="isShowShare" :type="2" @click-event="cancelSelect"></share>
    <move-and-copy v-if="perFileMoveAndCopy" :type="2" @pf3="parent2(1)"></move-and-copy>
  </div>
</template>

<script>
import { mapState } from "vuex";
import share from "@/CommonDP/components/documentRelevant/shareFile.vue";
import { filePreviewV1, tableRowIcon } from "@/CommonDP/utils/docPublic";
import docService from "@/CommonDP/service/doc-service";
import { downloadFile, downloadUrltoken, gentlyUrl } from "@/CommonDP/utils";
import { getToken } from "@/CommonDP/utils";
import MoveAndCopy from "@/CommonDP/components/documentRelevant/moveAndCopy.vue";
import fileLightFlag from "@/CommonDP/components/fileLightFlag";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import mongeService from "@/CommonDP/mongeView/service/monge-service";
export default {
  components: { MoveAndCopy, share, fileLightFlag },
  data() {
    return {
      downMydoc: checkPermission(this.$allPerms.MYDOC_DOWN),
      deleMydoc: checkPermission(this.$allPerms.MYDOC_DELE),
      rechristenCommitName: "",
      isShowRechristen: [],
      cacheListContent: {
        createFolder: {}
      },
      Token: {
        Token: getToken()
      },
      actionUrl: "",
      accept: "",
      qinglianghuaList: [],
      fileList: [],
      argument: {
        folderId: "0",
        isPersonal: 1,
        isRead: 1,
        priviAll: "1",
        enterpriseId: "",
        noRightClickMenu: true,
        type: "",
        versionId: ""
      },
      argument1: {
        folderId: "",
        folderNew: 1,
        isPersonal: 1,
        isRead: 1,
        priviAll: "1",
        enterpriseId: "",
        noRightClickMenu: true,
        type: "",
        versionId: ""
      },
      list: [],
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      shoucang: require("@/CommonDP/assets/shoucang.png"),
      weishoucang: require("@/CommonDP/assets/weishoucang.png"),
      timer: null, // 定时器
      keyone: 1
    };
  },
  computed: {
    ...mapState({
      isShowShare: state => state.XtDesign.isShowShare,
      currentNode: state => state.perFile.currentTreeNodeDan,
      navArr: state => state.perFile.navArrDan,
      perFileMoveAndCopy: state => state.perFile.moveAndCopy,
      jumpsta: state => state.perFile.jumpsta,
      refreshKey: state => state.perFile.refreshKey,
      refreshFolderID: state => state.perFile.refreshFolderID,
      enterpriseId: state => state.enterprise.enterpriseId,
      userInfo: state => state.user.userInfo,
      delFolderID: state => state.perFile.delFolderID
    })
  },
  watch: {
    navArr(newValue) {
      if (newValue) {
        this.keyone += 1;
        this.searchFolderExpand(newValue);
      }
    },
    refreshKey(newValue, oldValue) {
      console.log("上传成功啦");
      const data = this.currentNode;
      if (newValue && this.refreshFolderID === data.folderId) {
        this.parent2();
      }
    },
    isShowShare(newValue) {
      if (newValue) {
        console.log(newValue, "5555");
      }
    },
    delFolderID() {
      this.keyone += 1;
    },
    keyone(newValue) {
      if (newValue) {
        this.$store.dispatch("XtDesignUpdateSelect", []);
      }
    }
  },
  created() {
    this.argument.enterpriseId = this.enterpriseId;
    this.argument1.enterpriseId = this.enterpriseId;
    if (!this.$store.state.perFile.navArrDan.length) {
      this.querlist();
    } else {
      this.querlist3();
    }
    this.$store.dispatch("XtDesignUpdateSelect", []);
  },
  beforeDestroy() { // 页面关闭时清除定时器
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    cancelSelect() {
      this.$refs.multipleTable.clearSelection();
    },
    async querlist() {
      try {
        const result = await docService.querypersonalTree(this.argument);
        if (result.result === "0") {
          this.argument1.folderId = result.data[0].folderId;
          this.$store.dispatch("perFileUpdateNavDan", [result.data[0]]);
        }
      } catch (e) {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: true,
          message: e.message || "加载失败"
        });
      }
    },
    async querlist3() {
      try {
        this.argument1.folderId = this.currentNode.folderId;
        this.querlist2(this.argument1);
      } catch (e) {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: true,
          message: e.message || "加载失败"
        });
      }
    },
    async querlist2(data) {
      try {
        const result = await docService.querypersonalTree(data);
        if (result.result === "0") {
          this.list = result.data;
          if (!this.timer) {
            this.timer = setInterval(() => {
              this.timerQueryPersonalTree(data);
            }, 14000);
          }
        }
      } catch (e) {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: true,
          message: e.message || "加载失败"
        });
      }
    },
    async timerQueryPersonalTree(data) {
      try {
        const result = await docService.querypersonalTree(data);
        if (result.result === "0") {
          this.list = result.data;
        }
      } catch (e) {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: true,
          message: e.message || "加载失败"
        });
      }
    },
    async querlist4(data) {
      try {
        const result = await docService.querySearchFolder(data);
        if (result.result === "0") {
          this.list = result.data;
        }
      } catch (e) {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: true,
          message: e.message || "加载失败"
        });
      }
    },

    // 取消收藏
    delCol(val) {
      this.$store.dispatch("perFileUpdateMessageObj", {
        isShow: true,
        message: "取消收藏中..."
      });
      const param = {
        folderId: val.folderId,
        folderName: val.folderName,
        isFolder: val.isFolder,
        prjId: ""
      };
      docService.deletePersonFavorite(param).then(res => {
        if (res.result === "0") {
          this.$store.dispatch("perFileUpdateNodeList");
          this.$message.success("取消收藏成功");
          this.querlist2(this.argument1);
          this.$store.dispatch("perFileUpdateMessageObj", {
            isShow: false,
            message: ""
          });
        }
      });
    },

    // 收藏
    collectFile(val) {
      this.$store.dispatch("perFileUpdateMessageObj", {
        isShow: true,
        message: "收藏中..."
      });
      const param = {
        folderId: val.folderId,
        folderName: val.folderName,
        isFolder: val.isFolder,
        prjId: "MyDoc",
        enterpriseId: this.enterpriseId
      };
      docService.addPersonFavorite(param).then(res => {
        if (res.result == "0") {
          this.$store.dispatch("perFileUpdateNodeList");
          this.$message.success("收藏成功");
          this.querlist2(this.argument1);
          this.$store.dispatch("perFileUpdateMessageObj", {
            isShow: false,
            message: ""
          });
        }
      });
    },

    // 点击文件名称
    async clickFolderFile(row, event) {
      const { isFolder } = row;
      if (isFolder === 1) {
        this.$store.dispatch("perFileUpdateTreeNodeDan", row);
        this.navArr.push(row);
        this.$store.dispatch("perFileUpdateNavDan", this.navArr);
      } else {
        if (isFolder === 1) {
          return;
        } else if (row.isDelete === 1) {
          this.$message.warning("该文件已删除，无法查看");
        } else {
          this.viewFile(row, event);
        }
      }
    },

    async viewFile(row, event) {
      this.onLineView(row);
    },

    async onLineView(row) {
      const { status, folderId: fileId, fileVersion: versionId, parentId, fileType } = row;
      const data = { status, fileId, versionId, parentId, fileType };
      filePreviewV1(data, this.list);
    },

    async downloadFile(row) {
      const prjId = "MyDoc";
      const userInfo = this.userInfo;
      const { userId, token } = userInfo;
      if (row.isFolder !== 1) {
        const fileId = row.folderId;
        const version = row.fileVersion;
        const { data } = await mongeService.getFileDetails(fileId);
        const versionNew = data.version;
        if (versionNew != version) {
          this.$message.warning('文件已修改升级，请刷新页面后下载');
          return;
        }
        const downzipurl = downloadUrltoken(prjId, fileId, version);
        downloadFile(downzipurl);
      } else {
        var params = {
          folderId: row.folderId,
          rootDirectory: row.folderName,
          prjId: prjId,
          enterpriseId: this.enterpriseId,
          userId: userId
        };
        console.log(params);
        docService.downloadfolder(params).then(response => {
          const fileName = row.folderName + ".zip";
          if ("msSaveOrOpenBlob" in navigator) {
            // 兼容ie
            // var blob = response
            window.navigator.msSaveOrOpenBlob(response, fileName);
            return;
          } else {
            const link = document.createElement("a");
            const blob = response;
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURI(fileName));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        });
      }
    },

    async rechristen({ $index, row }) {
      this.isShowRechristen = [];
      if (row.isFolder === 1) {
        this.rechristenCommitName = row.folderName;
      } else {
        const typeIndex = row.folderName.lastIndexOf(".");
        const newName = row.folderName.substring(0, typeIndex);
        this.rechristenCommitName = newName;
      }
      this.isShowRechristen[$index] = true;
      this.$set(this.isShowRechristen, $index, true);
      this.$nextTick(() => {
        const ref = "input" + row.folderId;
        this.$refs[ref].focus();
      });
    },

    async commit(row) {
      let name = this.rechristenCommitName.replace(/\s*/g, "");
      if (!name || name.length < 1 || name.length > 80) {
        return this.$message.warning("名字不能为空且不超过80个字符");
      }
      const { isFolder } = row;
      var id = row.folderId;
      const prjId = this.enterpriseId;
      var remark = "";
      if (row.isFolder === 0) {
        const fileTypeArr = row.folderName.split(".");
        name = `${name}.${fileTypeArr[fileTypeArr.length - 1]}`;
      }
      try {
        const result = await docService.renameMyDoc({
          name,
          id,
          remark,
          isFolder,
          prjId
        });
        if (result.result === "0") {
          this.isShowRechristen = [];
          this.$message.success("修改成功");
          row.folderName = name;
          this.querlist2(this.argument1);
        }
      } catch (e) {
        console.log(e, 'e');
      }
    },

    updateLight(row, type) {
      const prjId = this.enterpriseId;
      row.status = "1";
      const status = row.status;
      let messageType;
      type === 1 ? (messageType = "优先轻量化操作") : (messageType = "重新轻量化操作");
      docService
        .updateLight(prjId, row.folderId, row.fileVersion)
        .then(res => {
          if (res.result === "0") {
            row.status = "1";
            this.$message.success(`${messageType}成功`);
          } else {
            row.status = status;
            this.$message.warning(`${messageType}失败`);
          }
        })
        .catch(() => {
          row.status = status;
        });
    },

    handleBeforeUpload(file) {
      const lastObj = this.qinglianghuaList[this.qinglianghuaList.length - 1];
      const uploadFileName = this._splitFileName(file.name);
      const rvtFileName = this._splitFileName(lastObj.folderName);
      if (uploadFileName !== rvtFileName) {
        this.$message({
          message: `请选择和${lastObj.fileType === 7 ? "rvt" : "skp"}文件匹配的轻量化文件`,
          type: "warning",
          duration: 2000,
          showClose: true
        });
        return false;
      }
      const rvtId = lastObj.folderId;
      lastObj.status = "1";
      this.$message.success("操作成功,正在轻量化");
    },

    _splitFileName(text) {
      const pattern = /\.{1}[a-zA-Z]{1,}$/;
      if (pattern.exec(text) !== null) {
        return text.slice(0, pattern.exec(text).index);
      } else {
        return text;
      }
    },

    _splitFileType(text) {
      const lastIndex = text.lastIndexOf(".");
      return text.substring(lastIndex + 1);
    },

    handleAvatarSuccess(response, file, fileList) {
      let status;
      let message;
      let type;
      if (response.data.code === 0) {
        status = "2";
        message = "文件轻量化成功";
        type = "success";
      } else {
        status = "";
        message = response.data.msg || "轻量化失败,请重新轻量化";
        type = "warning";
      }
      const rvtId = response.data.rvtId;
      const obj = this.qinglianghuaList.find(item => item.folderId === rvtId);
      obj.status = status;
      this.$message({
        message: message,
        type: type,
        duration: 2000,
        showClose: true
      });
      const index = this.qinglianghuaList.findIndex(item => item.folderId === rvtId);
      if (index > -1) {
        this.qinglianghuaList.splice(index, 1);
      }
    },

    handleError(err, file, fileList) {
      this.$message({
        message: "文件轻量化失败,请重新轻量化",
        type: "warning",
        duration: 2000,
        showClose: true
      });
    },

    async gently(scope) {
      const { row } = scope;
      this.qinglianghuaList.push(row);
      if (row.fileType === 7) {
        this.accept = ".bimex";
      } else {
        this.accept = ".bimex,.usdp";
      }
      const prjId = this.enterpriseId;
      const rvtId = row.folderId;
      const rvtVersion = row.fileVersion;
      this.actionUrl = gentlyUrl(rvtId, prjId, rvtVersion);
      this.$nextTick(() => {
        const gentlyBtn = document.getElementById("gentlyBtn");
        if (gentlyBtn) {
          gentlyBtn.click();
        }
      });
    },

    async deleteRow(row) {
      const folderId = row.folderId;
      try {
        this.$confirm("确定删除吗?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false
        })
          .then(async () => {
            this.$store.dispatch("perFileUpdateMessageObj", {
              isShow: true,
              message: "删除中..."
            });
            const result = await docService.queryDeleteFile([folderId]);
            if (result.result === "0") {
              this.querlist2(this.argument1);
              this.$store.dispatch("perFileUpdateMessageObj", {
                isShow: false,
                message: ""
              });
              this.$message({ type: "success", message: "删除成功" });
            }
          })
          .catch(() => {});
      } catch (e) {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: false,
          message: ""
        });
      }
    },

    isFinalGently(row) {
      return row.fileType === 7 || row.fileType === 18 || row.fileType === 19;
    },

    clickRow(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },

    selectChange(selection) {
      this.$store.dispatch("XtDesignUpdateSelect", selection);
    },

    formatterFileSize(row, column) {
      if (row.fileSize === "0B") {
        return "-";
      } else {
        return row.fileSize;
      }
    },

    className(row) {
      return tableRowIcon(row);
    },

    searchFolderExpand(val) {
      if (val.length) {
        var arr = val[val.length - 1];
        this.$store.dispatch("perFileUpdateTreeNodeDan", arr);
        this.argument1.folderId = arr.folderId;
        this.querlist2(this.argument1);
      }
    },
    parent2(val) {
      if (val) {
        this.keyone += 1;
      }
      this.querlist2(this.argument1);
    },
    blur() {
      setTimeout(() => {
        this.isShowRechristen = [];
      }, 500);
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#mydocfileTable {
  width: 100%;
  height: 1px;
  flex-grow: 1;
  padding: 0px var(--big-space) var(--middle-space);

  /deep/ .el-table {
    .el-table__body-wrapper {
      .rowIcon {
        cursor: pointer;
        color: #A1C5E7;
        font-size: 16px;
        margin-right: 6px;
      }
    }

    .el-table__body-wrapper::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-track {
      background: rgb(255, 255, 255);
      border-radius: 2px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background: #eee;
      border-radius: 10px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background: #C4C6CC;
    }
  }
}
</style>
